import axios from "axios";
import { logger } from "../utilities/logger";
const URL = window.RUNTIME_CONFIG.API_BASE_URL;
const BASE_URL = `${URL}/pdf`;

export const filters = {
  jobId: "",
  clientName: "",
};

export class GeneratePDFService {
  static async FilterToPDF(filters) {
    try {
      const response = await axios.post(`${BASE_URL}/savefilter`, filters);
      return response.data;
    } catch (err) {
      logger.error("FilterToPDF failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async UploadTemplateToDocuSeal(documents) {
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          const response = await axios.post(`${BASE_URL}/uploadtodocuseal`, documents);
          resolve(response.data);
        } catch (err) {
          logger.error("UploadTemplateToDocuSeal failed:", err.response?.data ?? err.message);
          reject(err);
        }
      }, 0); // defers execution off the UI thread (Safari-friendly)
    });
  }

  static async UpdateTemplateToDocuSeal(documents) {
    try {
      const response = await axios.post(`${BASE_URL}/updatetodocuseal`, documents);
      return response.data;
    } catch (err) {
      logger.error("UpdateTemplateToDocuSeal failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async SendRequestForSignDocument(signRequest, jobId) {
    try {
      const response = await axios.post(`${BASE_URL}/sendsignrequest`, { signRequest, jobId });
      return response.data;
    } catch (err) {
      logger.error("SendRequestForSignDocument failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async GetAllJobId(userID, role) {
    try {
      const response = await axios.get(`${BASE_URL}/getalljobid?userid=${userID}&role=${role}`);
      return response.data;
    } catch (err) {
      logger.error("GetAllJobId failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async GetJobDetailById(jobid) {
    try {
      const response = await axios.get(`${BASE_URL}/getjobdetailbyid?jobid=${jobid}`);
      return response.data;
    } catch (err) {
      logger.error("GetJobDetailById failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async GetJobIds(jobid) {
    try {
      const response = await axios.get(`${BASE_URL}/getjobids?jobid=${jobid}`);
      return response.data;
    } catch (err) {
      logger.error("GetJobIds failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async UpdateJobIDContent(jobContent) {
    try {
      const response = await axios.post(`${BASE_URL}/updatejobidcontent`, jobContent);
      return response.data;
    } catch (err) {
      logger.error("UpdateJobIDContent failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async CheckJobContent(jobid) {
    try {
      const response = await axios.get(`${BASE_URL}/checkjobcontent?jobid=${jobid}`);
      return response.data;
    } catch (err) {
      logger.error("CheckJobContent failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async UpdateParentContent(jobContent) {
    try {
      const response = await axios.post(`${BASE_URL}/updateparentjson`, jobContent);
      return response.data;
    } catch (err) {
      logger.error("UpdateParentContent failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async GetChildContent(jobid) {
    try {
      const response = await axios.get(`${BASE_URL}/getchildjson?jobid=${jobid}`);
      return response.data;
    } catch (err) {
      logger.error("GetChildContent failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async DeleteChildJobID(jobid) {
    try {
      const response = await axios.get(`${BASE_URL}/deletechildjobid?jobid=${jobid}`);
      return response.data;
    } catch (err) {
      logger.error("DeleteChildJobID failed:", err.response?.data ?? err.message);
      throw err;
    }
  }

  static async fetchDesigner(jobId) {
    try {
      const response = await axios.get(`${BASE_URL}/getdesignerbyjobid?jobid=${jobId}`);
      const data = response.data;
      if (data && data.designer) {
        return data.designer;
      }
      throw new Error("Designer not in response");
    } catch (error) {
      logger.error("fetchDesigner failed:", error.message);
      return null;
    }
  }
}
